import { of } from 'rxjs';
import { delay } from 'rxjs/operators';

export const saveMbc$ = () => of({}).pipe(delay(1000));
